export const BASE_URL = "https://sendzip.onrender.com/api/";
// export const BASE_URL = "http://localhost:5000/api/";

//End Points
export const UPLOAD_ZIP = "zip/uploadZip/";
export const DOWNLOAD_ZIP = "zip/downloadZip/";
export const SEND_TEXT = "text/sendText/";
export const GET_TEXT = "text/getText/";
export const SEND_TEXT_WITHOUT_CODE = "text/sendTextWithoutCode";
export const GET_TEXT_WITHOUT_CODE = "text/getTextWithoutCode";

// Page Urls
export const sendZip = "/";
export const sendText = "/sendText";
